import axios from "axios";
import URLS from "./URLS";
import { disconnectSocket } from "../Socket/initializeSocket";
import { LOGOUT_ADMIN } from "./ApiCalls";

const API_URL = URLS.API_URL;
class Axios {
  defaultOptions = () => {
    if (typeof window === "undefined") {
      return {
        baseURL: `${API_URL}`,
        headers: {
          token: "",
          Authorization: "",
          adminid: "",
        },
      };
    }
    let lang = localStorage.getItem("i18nextLng");
    if (lang === "th") {
      lang = "thai"
    } else if (lang === "vi") {
      lang = "viet"
    }
    return {
      baseURL: `${API_URL}`,
      headers: {
        token: localStorage.getItem("token") || "",
        Authorization: "Bearer" + " " + localStorage.getItem("token") || "",
        adminid: (localStorage && localStorage.getItem("_id")) || "",
        language: lang,
        country: localStorage.getItem("country") ?? "Thailand",
      },
    };
  };

  LogoutUser = async (error) => {
    const status = error?.response?.status;
    console.log("status-0", status);
    console.log("error-0", error);

    if (status === 401) {
      try {
        const firebaseToken = localStorage.getItem("firebaseToken");

        if (firebaseToken) {
          await LOGOUT_ADMIN({ firebaseToken });
        }
      } catch (err) {
        console.error("Logout API failed:", err);
      } finally {
        disconnectSocket();
        // remove only auth-related data
        localStorage.clear();
        window.location.replace("/");
      }
    }
  };

  // LogoutUser = (url) => {
  //   if (url?.response !== undefined && url?.response?.status === 401) {
  //     console.log(url.response.status, "401 Unauthorized Api Call");
  //     localStorage.clear();
  //     window.location.replace("/");
  //   } else {
  //     console.log(url, "401 Unauthorized Api Call");
  //   }
  // };

  get = (url, options = {}) => {
    return axios
      .get(url, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message && res.data.message.includes("Not Authorized")) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };

  post = (url, data, options = {}) => {
    console.log("POST API>>>>>>>");
    return axios
      .post(url, data, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message && res.data.message.includes("Not Authorized")) {
          let err = {
            response: {
              status: 401,
            },
          };
          if (!url.includes("logout")) {
            this.LogoutUser(err);
          }
        } else {
          return res;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401 && !url.includes("logout")) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };

  put = (url, data, options = {}) => {
    return axios
      .put(url, data, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message && res.data.message.includes("Not Authorized")) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };

  delete = (url, options = {}) => {
    return axios
      .delete(url, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message && res.data.message.includes("Not Authorized")) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };
}

export default new Axios();
